// extracted by mini-css-extract-plugin
module.exports = {"my-groups-page-container":"MyGroups_my-groups-page-container__2Xu15","about-container":"MyGroups_about-container__28Jc0"};